import { useState } from 'react';
import Breadcrumb from '@/components/feature/Breadcrumb';

const testimonials = [
  {
    name: '小玲',
    role: '漫画爱好者',
    content: '迷妹漫画真的超级好用！下拉式阅读体验太棒了，躺着也能轻松看漫画。资源超全，更新也很快，已经推荐给身边所有爱看漫画的朋友了！',
    rating: 5,
  },
  {
    name: '阿杰',
    role: '大学生',
    content: '作为一个日漫死忠粉，迷妹漫画满足了我对漫画平台的全部期待。免费看、资源全、分类清晰，关键是阅读体验真的丝滑，比翻页式的舒服太多了！',
    rating: 5,
  },
  {
    name: '小美',
    role: '自由插画师',
    content: '我是被朋友安利来的，一开始还担心免费的会不会画质差，结果完全超出预期！画质清晰，加载快，而且漫画种类真的很全，国漫韩漫日漫都有，爱了爱了。',
    rating: 5,
  },
  {
    name: '大熊',
    role: '程序员',
    content: '工作之余就喜欢看看漫画放松一下，迷妹漫画的竖屏滚动模式太适合手机了，上厕所、等地铁的碎片时间也能看几话。全本免费这点真的良心！',
    rating: 4,
  },
  {
    name: '喵喵',
    role: '漫画博主',
    content: '做了三年漫画推荐博主，迷妹漫画是我目前用过的免费漫画平台里体验最好的。推荐算法也很准，经常能发现一些冷门好作品。希望平台越做越好！',
    rating: 5,
  },
  {
    name: '老张',
    role: '初中教师',
    content: '给班里的学生们推荐了这个平台，课余时间看看漫画放松一下，培养阅读兴趣。关键是全免费不用担心学生乱花钱，家长也很放心。',
    rating: 5,
  },
];

const stats = [
  { label: '漫画总量', value: '20,000+', icon: 'ri-book-open-line' },
  { label: '日活用户', value: '500万+', icon: 'ri-user-smile-line' },
  { label: '累计阅读', value: '100亿+', icon: 'ri-eye-line' },
  { label: '好评率', value: '98.6%', icon: 'ri-heart-line' },
];

export default function AboutPage() {
  const [formState, setFormState] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('website_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setFormState('success');
      setFormMessage('提交成功！感谢您的留言。');
      form.reset();
      setTimeout(() => { setFormState('idle'); setFormMessage(''); }, 3000);
      return;
    }

    formData.delete('website_alt');

    setFormState('submitting');

    try {
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        params.append(key, String(value));
      });

      const response = await fetch('https://readdy.ai/api/form/d9on840senbniolesi6g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      const serverMsg = (parsed?.meta as Record<string, unknown>)?.message || parsed?.message || responseText;

      if (response.ok && parsed?.code === 'OK') {
        setFormState('success');
        setFormMessage('提交成功！感谢您的留言，我们会尽快回复。');
        form.reset();
      } else {
        const msg = String(serverMsg || '');
        if (msg.includes('spam') || msg.includes('form data is spam')) {
          setFormState('success');
          setFormMessage('提交成功！感谢您的留言。');
          form.reset();
        } else {
          setFormState('error');
          setFormMessage(String(serverMsg || '提交失败，请稍后重试。'));
        }
      }
    } catch {
      setFormState('error');
      setFormMessage('网络异常，请稍后重试。');
    }

    setTimeout(() => { setFormState('idle'); setFormMessage(''); }, 4000);
  };

  return (
    <>
      <Breadcrumb items={[{ label: '关于我们' }]} />

      {/* Brand Story */}
      <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-16">
        <div className="text-center mb-10">
          <h1 className="text-3xl md:text-4xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            关于迷妹漫画
          </h1>
          <p className="mt-3 text-foreground-500 max-w-2xl mx-auto">一个为漫画爱好者打造的免费阅读乐园</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="text-xl font-bold text-foreground-900 mb-4" style={{ fontFamily: "var(--font-heading)" }}>我们的故事</h2>
            <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
              <p>迷妹漫画成立于2020年，由一群热爱漫画的年轻人共同创办。我们深知漫画迷们在寻找高质量免费漫画资源时面临的困扰——要么画质模糊、要么更新缓慢、要么阅读体验不佳。</p>
              <p>带着「让每一个漫画迷都能免费享受优质漫画阅读体验」的初心，我们打造了迷妹漫画这个平台。从最初的几百部漫画到如今超过两万部的海量资源库，迷妹漫画始终坚持全本免费、下拉式流畅阅读的核心理念。</p>
              <p>我们采用创新的下拉式滚动阅读技术，让漫画阅读告别翻页的繁琐，完美适配竖屏手机和电脑端，带给用户如同在纸质漫画书上阅读般的流畅体验。</p>
              <p>无论是日漫、韩漫还是国漫，无论是热血战斗还是甜蜜恋爱，迷妹漫画致力于成为每一位漫画爱好者的首选免费漫画平台。</p>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden h-[350px]">
            <img
              src="https://readdy.ai/api/search-image?query=A%20cozy%20modern%20reading%20corner%20with%20a%20tablet%20displaying%20colorful%20manga%20art%2C%20surrounded%20by%20comic%20books%20and%20warm%20ambient%20lighting%2C%20minimalist%20interior%20design%2C%20soft%20natural%20light%20from%20window%2C%20warm%20beige%20and%20cream%20tones%2C%20cozy%20atmosphere&width=800&height=700&seq=about-brand-01&orientation=landscape"
              alt="迷妹漫画 - 舒适阅读体验"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="bg-background-100 py-10 md:py-14">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {stats.map(stat => (
              <div key={stat.label} className="bg-white rounded-xl p-6 text-center border border-background-200/50">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-50 flex items-center justify-center">
                  <i className={`${stat.icon} text-xl text-primary-500 w-6 h-6 flex items-center justify-center`}></i>
                </div>
                <div className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>{stat.value}</div>
                <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Reputation */}
      <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-16">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>用户口碑</h2>
          <p className="text-sm text-foreground-500 mt-1">来自真实用户的评价</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((t, idx) => (
            <div key={idx} className="bg-white rounded-xl p-5 border border-background-200/50">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }, (_, i) => (
                  <i
                    key={i}
                    className={`w-4 h-4 flex items-center justify-center text-sm ${i < t.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{t.content}</p>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center text-sm font-bold text-secondary-600">
                  {t.name[0]}
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{t.name}</div>
                  <div className="text-xs text-foreground-400">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Contact */}
      <section className="bg-background-100 py-10 md:py-16">
        <div className="max-w-2xl mx-auto px-4 md:px-6">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>联系我们</h2>
            <p className="text-sm text-foreground-500 mt-1">有任何问题或建议，欢迎给我们留言</p>
          </div>

          {formMessage && (
            <div className={`mb-4 p-4 rounded-xl text-sm ${
              formState === 'success' ? 'bg-green-50 text-green-700 border border-green-200' :
              formState === 'error' ? 'bg-red-50 text-red-700 border border-red-200' : ''
            }`}>
              {formMessage}
            </div>
          )}

          <form onSubmit={handleSubmit} className="bg-white rounded-2xl p-6 md:p-8 border border-background-200/50" data-readdy-form>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1">姓名</label>
                <input
                  id="contact-name"
                  name="name"
                  type="text"
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                  placeholder="请输入您的姓名"
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1">邮箱</label>
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                  placeholder="请输入您的邮箱"
                />
              </div>
            </div>
            <div className="mt-4">
              <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1">主题</label>
              <input
                id="contact-subject"
                name="subject"
                type="text"
                required
                className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                placeholder="请输入主题"
              />
            </div>
            <div className="mt-4">
              <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1">留言内容</label>
              <textarea
                id="contact-message"
                name="message"
                rows={5}
                required
                maxLength={500}
                className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                placeholder="请输入您的留言内容（500字以内）"
              ></textarea>
              <p className="text-xs text-foreground-400 mt-1">最多500个字符</p>
            </div>
            <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            <button
              type="submit"
              disabled={formState === 'submitting'}
              className="mt-6 w-full py-3 bg-primary-500 text-white rounded-full font-semibold text-sm hover:bg-primary-600 disabled:opacity-60 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
            >
              {formState === 'submitting' ? '提交中...' : '发送留言'}
            </button>
          </form>
        </div>
      </section>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "关于迷妹漫画",
            "description": "迷妹漫画成立于2020年，是一个专注于免费漫画在线阅读的平台，提供海量日韩国漫资源。",
            "url": "https://mimei-comic.com/about",
            "inLanguage": "zh-CN",
            "isPartOf": {
              "@type": "WebSite",
              "name": "迷妹漫画",
              "url": "https://mimei-comic.com",
            },
          }),
        }}
      />
    </>
  );
}